/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============== QUICK SEARCH JAVASCRIPT =============== */
/* ======================== Earth ======================= */
/* ====================================================== */
/* ====================================================== */

var klevu_layoutType = 'slim';

window._klvReady = window._klvReady || [];
window._klvReady.push(function() {
    window.klevu.interactive(function() {
klevu({
  theme: {
      setHelpers: {
          "all": {
              namePrettifier: function (name) {
                  return name.replace(/[\[\]"]/g, '');
              }
          }
      }
  }
});

});

klevu.beforeActivation("quick", function(data, scope){
    klevu.each(klevu.search.extraSearchBox, function (key, box) {
        box.getScope().template.setTemplate(klevuQuickTrendingProductBlockCustom, 'klevuQuickTrendingProductBlock', true);
        box.getScope().template.setTemplate(klevuQuickProductsCustom, 'klevuQuickProducts', true);
        box.getScope().template.setTemplate(klevuQuickTemplateBaseCustom, 'klevuTemplateBase', true);
        box.getScope().template.setTemplate(klevuQuickProductBlockCustom, 'klevuQuickProductBlock', true);
    });
});

klevu.afterTemplateRender('quick', function (data, scope) {

    function setKlevuQuickPopupTopPositionVariable() {
        klevu.each(klevu.dom.find('.klevuWrap'), function (key, currentElement) {
            const topPosition = currentElement.getBoundingClientRect().top;
            document.documentElement.style.setProperty('--klevuQuickPopupTopPosition', `${topPosition}px`);
        });
    }
    setKlevuQuickPopupTopPositionVariable();
    window.addEventListener('resize', setKlevuQuickPopupTopPositionVariable);    

});
klevu.support.hook(['recs'], function() {
    klevu({
      powerUp: {
        catnav: true,
        landing: true,
      },
    });
  });
});

/* ============== QUICK SEARCH TEMPLATES =============== */

var klevuQuickTrendingProductBlockCustom = `
<% 
var updatedProductName = dataLocal.name;
if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
    if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
        updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
    }
}
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuQSMenuItemTarget kuTrackRecentView">
<div class="klevuProductItemTop">
    <div class="klevuQuickImgWrap">
        <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
        <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
    </div>
</div>
<div class="klevuProductItemBottom">
    <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
        <div class="klevu-brand"><%= dataLocal.brand %></div>
    <% } %>
    <div class="klevuQuickProductDescBlock">
        <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
        <div class="klevuQuickProductDesc">
            <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
            <div class="klevuQuickProductPrice">
            <%
                var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
            %>
            <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                <div class="klevuQuickSalePrice kuStartPrice">
                    <span class="klevuQuickPriceGreyText"><%=helper.translate("From")%></span>
                    <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                </div>
            <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                <span class="klevuQuickOrigPrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
                <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                    <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                </span>
            <% } else if(!Number.isNaN(kuSalePrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                </span>
            <% } else if(!Number.isNaN(kuPrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
            <% } %>
        </div>
        </div>                
    </div>
</div>        
</a>`;

var klevuQuickProductsCustom = `
<% if(data.query.productList) { %>
    <% if(data.query.productList.result.length > 0 ) { %>
        <div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content" data-content="productList" >
            <section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left"
                data-container-role="left">
                <div ku-block data-block-id="ku_quick_left_facets">
                    <% var isQuickFiltersOnLeft = klevu.search.modules.kmcInputs.base.isQuickFacetedLayoutFilterOnLeft(); %>
                    <% if(isQuickFiltersOnLeft === true && data.query.productList.filters && data.query.productList.filters.length > 0) { %>
                        <div data-section="productList" class="klevuMeta">
                            <%=helper.render('klevuQuickTemplateFilters',scope,data,"productList") %>
                        </div>                        
                    <% } %>
                </div>
                <div ku-block data-block-id="ku_quick_left_call_outs"></div>
                <div ku-block data-block-id="ku_quick_left_banner"></div>
            </section>
            <section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center"
                data-container-role="center">
                <header ku-block data-block-id="ku_quick_result_header"></header>
                <div ku-block data-block-id="ku_quick_result_items">
                    <div class="klevuResultsBlock">                            
                        <%=helper.render('klevuQuickProductBlockTitleHeader',scope,data) %>
                        <div class="klevuQuickSearchResults klevuMeta productList" data-section="productList" id="productList" data-result-view="list" >
                            <div class="kuQuickResultsListHeader">
                                <%=helper.render('kuTemplateQuickResultsViewSwitch',scope,data,"productList") %>
                                <%=helper.render('klevuQuickTemplateSortBy',scope,data,"productList") %>                                        
                            </div>
                            <div class="kuClearBoth"></div>
                            <div class="kuQuickResultsListContainer">
                                <ul>
                                    <% helper.each(data.query.productList.result,function(key,product){ %>
                                        <%=helper.render('klevuQuickProductBlock',scope,data,product) %>
                                    <% }); %>
                                    <%=helper.render('klevuQuickTemplateInfiniteScrollDown',scope,data) %>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div ku-block data-block-id="ku_quick_other_items">
                    <div data-section="productList" class="klevuMeta">
                        <%=helper.render('klevuQuickTemplatePagination',scope,data,"productList") %>
                    </div>
                </div>
                <footer ku-block data-block-id="ku_quick_result_footer">
                    <div class="klevuProductsViewAll">
                        <% var queryParam = klevu.getSetting(klevu, "settings.url.queryParam"); %>
                        <a href="<%=helper.buildUrl(data.settings.landingUrl, queryParam ,helper.stripHtml(data.settings.term))%>"
                            target="_parent"><span><%=helper.translate("View All Results")%></span>
                        </a>
                    </div>
                </footer>
            </section>
            <section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right"
                data-container-role="right">
                <div ku-block data-block-id="ku_quick_right_facets">
                    <% var isQuickFiltersOnLeft = klevu.search.modules.kmcInputs.base.isQuickFacetedLayoutFilterOnLeft(); %>
                    <% if(isQuickFiltersOnLeft === false && data.query.productList.filters && data.query.productList.filters.length > 0) { %>
                        <div data-section="productList" class="klevuMeta">
                            <%=helper.render('klevuQuickTemplateFilters',scope,data,"productList") %>
                        </div>                        
                    <% } %>
                </div>
                <div ku-block data-block-id="ku_quick_right_call_outs"></div>
                <div ku-block data-block-id="ku_quick_right_banner"></div>
            </section>
        </div>
    <% } else { %>
        <% var isCmsEnabled = klevu.search.modules.kmcInputs.base.getCmsEnabledValue(); %>
        <% if(isCmsEnabled) { %>
            <% if(data.query.cmsCompressed && data.query.cmsCompressed.result.length <= 0 ){ %>
                <div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
                    <section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left"
                        data-container-role="left">
                    </section>
                    <section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center"
                        data-container-role="center">
                        <div ku-block data-block-id="ku_quick_no_result_items">
                            <%=helper.render('noResultsFoundQuick',scope) %>
                        </div>
                    </section>
                    <section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right"
                        data-container-role="right">
                    </section>
                </div>
            <% } %>
        <% } else { %>
            <div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
                <section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left"
                    data-container-role="left">
                </section>
                <section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center"
                    data-container-role="center">
                    <div ku-block data-block-id="ku_quick_no_result_items">
                        <%=helper.render('noResultsFoundQuick',scope) %>
                    </div>
                </section>
                <section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right"
                    data-container-role="right">
                </section>
            </div>
        <% } %>
    <% } %>
<% } else { %>        
<% } %>`;

var klevuQuickTemplateBaseCustom = `
<% var noResultsClass = '';
    if(typeof data.query.productList !== 'undefined' && data.query.productList.result.length === 0){
        noResultsClass = 'klevu-no-results';
    }
%>
<div class="klevu-fluid kuPreventDocumentClick">
    <%= helper.render('customBlockTopOuter',scope) %>
    <div id="klevuSearchingArea" class="klevuQuickSearchingArea <%=noResultsClass %>">
        <div ku-container data-container-id="ku_quick_main_container" data-container-role="main">
            <%= helper.render('customBlockTop',scope) %>
            <header ku-container data-container-id="ku_quick_main_header_container" data-container-role="header">
                <section ku-block data-block-id="ku_quick_main_header_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_header_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"top") %>                    
                </section>
                <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                    <div class="klevuSuggestionsBlock">                            
                        <%=helper.render('klevuQuickAutoSuggestions',scope) %>
                        <%=helper.render('klevuQuickPageSuggestions',scope) %>
                        <%=helper.render('klevuQuickCategorySuggestions',scope) %>
                    </div>
                </section>
            </header>
            
            <% if(data.showQuickFacetedLayoutCharLimitMessage == true) { %>
                <% var quickFacetedLayoutMessage = (data.quickFacetedLayoutMinCharsTextValue) ? data.quickFacetedLayoutMinCharsTextValue : ""; %>
                <% if(quickFacetedLayoutMessage != "") { %>
                    <span class="kuFacetedLayoutMinCharText"><%= helper.translate(quickFacetedLayoutMessage) %></span>
                <% } %>                    
            <% } else { %>
                <% if(data.query.productList) { %>
                    <%=helper.render('klevuQuickTemplateResultsHeadingTitle',scope,data,"productList") %>
                    <%= helper.render('klevuQuickTemplateTabResults',scope) %>                                                 
                    <%= helper.render('klevuQuickProducts',scope) %>
                    <%= helper.render('klevuQuickOtherContent',scope) %>
                <% } else { %>              
                    <div class="kuSearchPersonalizationsContainer">
                        <%= helper.render('klevuSearchPersonalizations',scope) %>    
                    </div>
                <% } %>  
            <% } %>
        
            <footer ku-container data-container-id="ku_quick_main_footer_container" data-container-role="footer">
                <section ku-block data-block-id="ku_quick_main_footer_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_footer_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"bottom") %>
                </section>
            </footer> 
            <%= helper.render('customBlockBottom',scope) %>
        </div>
    </div>
</div>`;

const klevuQuickProductBlockCustom  = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
    <a title="<%= updatedProductName %>" target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>"  class="klevuQuickProductInnerBlock trackProductClick kuTrackRecentView">
        <div class="klevuProductItemTop">
            <div class="klevuQuickImgWrap">
                <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
                <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
                </div>
        </div>
        <div class="klevuProductItemBottom">
            <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
                <div class="klevu-brand"><%= dataLocal.brand %></div>
            <% } %>
            <div class="klevuQuickProductDescBlock">
                <div title="<%= updatedProductName %>" class="klevuQuickProductName kuClippedOne"> <%= updatedProductName %> </div>
                <div class="klevu-desc-l2 kuClippedOne"> <%=dataLocal.shortDesc%> </div>
                <div class="klevuQuickProductDesc kuClippedOne">
                    <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
                </div>
                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('quickProductStock', scope, data, dataLocal) %>              
                <% } else { %>
                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="klevuQuickProductPrice kuClippedOne">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                            <div class="klevuQuickSalePrice kuStartPrice">
                                <span class="klevuQuickPriceGreyText"><%=helper.translate("From")%></span>
                                <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                            </div>
                        <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                            <span class="klevuQuickOrigPrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                            <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                                <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                            </span>
                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                            </span>
                        <% } else if(!Number.isNaN(kuPrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                        <% } %>
                    </div>
                    <%=helper.render('searchResultProductVATLabelQuick', scope, data, dataLocal) %>
                    <% } %>
                <% } %>
                <%=helper.render('klevuQuickProductRating',scope,data,dataLocal) %>
            </div>
        </div>
        <div class="kuClearLeft"></div>
    </a>
    <%=helper.render('quickSearchProductAddToCart',scope,data,dataLocal) %>        
</li>`;